// extracted by mini-css-extract-plugin
export default {"engDiagTheme":"eng-diag-theme_engDiagTheme__J1r-T"};